<template>
  <div class="search-filter">
    <b-row>
      <b-col>
        <div>
          <b-form-group :label="$t('VMX.user_documents_filter_label_search')">
            <b-input-group>
              <b-form-input debounce="500" v-model="filter" :placeholder="$t('VMX.user_documents_filter_placeholder_search')"></b-form-input>
              <b-input-group-append>
<!--                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>-->
                <b-input-group-text @click="filter = ''" style="cursor:pointer;">
                  <b-icon icon="x" />
                </b-input-group-text>
              </b-input-group-append>

            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="eventFilter">
      <b-col>
        <b-form-group :label="$t('VMX.user_documents_filter_label_event')" label-for="tags-component-select">
          <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
          <b-form-tags
            id="event-tags-component-select"
            v-model="values.eventValue"
            size="lg"
            class="mb-2"
            add-on-change
            no-outer-focus
          >
            <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                <li v-for="tag in tags" :key="tag" class="list-inline-item">
                  <b-form-tag
                    :style="backgroundColor"
                    @remove="removeTag(tag)"
                    :title="tag"
                    :disabled="disabled"
                    variant=""
                  >{{ tag.toUpperCase() }}</b-form-tag>
                </li>
              </ul>
              <b-form-select
                v-bind="inputAttrs"
                v-on="inputHandlers"
                :disabled="disabled || availableEventOptions.length === 0"
                :options="availableEventOptions"
              >
                <template #first>
                  <!-- This is required to prevent bugs with Safari -->
                  <option disabled value="">{{ $t('VMX.user_documents_filter_placeholder_event') }}</option>
                </template>
              </b-form-select>
            </template>
          </b-form-tags>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :label="$t('VMX.user_documents_filter_label_type')" label-for="tags-component-select">
          <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
          <b-form-tags
            id="type-tags-component-select"
            v-model="values.typeValue"
            size="lg"
            class="mb-2"
            add-on-change
            no-outer-focus
          >
            <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                <li v-for="tag in tags" :key="tag" class="list-inline-item">
                  <b-form-tag
                    @remove="removeTag(tag)"
                    :title="tag"
                    :disabled="disabled"
                    variant=""
                  >{{ tag }}</b-form-tag>
                </li>
              </ul>
              <b-form-select
                v-bind="inputAttrs"
                v-on="inputHandlers"
                :disabled="disabled || availableTypeOptions.length === 0"
                :options="availableTypeOptions"
              >
                <template #first>
                  <!-- This is required to prevent bugs with Safari -->
                  <option disabled value="">{{ $t('VMX.user_documents_filter_placeholder_type') }}</option>
                </template>
              </b-form-select>
            </template>
          </b-form-tags>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: 'TextSearch',
  props: {
    userDocuments: {
      type: Array,
      default: () => [],
    },
    eventFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      filter: null,
      values: {
        eventValue: [],
        typeValue: []
      }
    }
  },
  computed: {
    ...mapGetters({
      config: 'ModuleConfig/moduleConfig'
    }),
    backgroundColor() {
      let color = null
      if (this.config?.color) {
        color = `backgroundColor: ${this.config.color}`
      }
      return color
    },
    availableEvents() {
      return [
        ...new Set(this.userDocuments.map(e => e.EventShort.toUpperCase())),
        ...new Set(this.userDocuments.map(e => e.SocietyShort.toUpperCase()))
      ].filter(d => d.trim() !== '')
    },
    availableEventOptions() {
      return this.availableEvents.filter(opt => this.values.eventValue.indexOf(opt) === -1)
    },
    availableTypes() {
      return [...new Set(this.userDocuments.map(e => e.FileType))].filter(d => d.trim() !== '')
    },
    availableTypeOptions() {
      return this.availableTypes.filter(opt => this.values.typeValue.indexOf(opt) === -1)
    },
  },
  watch: {
    filter() {
      this.$emit("filter", this.filter);
    },
    values: {
      handler() {
        this.debounceSearch()
      },
      deep: true
    }
  },
  methods: {
    debounceSearch() {
      setTimeout(() => {
        this.$emit("search", this.values);
      }, 400)
    }
  }
}
</script>

<style scoped>

</style>
